import styled, { keyframes } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Props } from './index';

const shimmerAnimation = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const ShimmerBase = styled.span.attrs(({ circle, width, height, fontSize }: Props) => ({
  circle,
  width,
  height,
  fontSize,
}))`
  display: inline-block;
  width: ${({ width }) => (width ? width : 'auto')};
  height: ${({ height }) => (height ? height : 'auto')};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '1em')};
  border-radius: ${({ circle }) => (circle ? '50%' : '8px')};

  animation: ${shimmerAnimation} 2s infinite;
  background: linear-gradient(
    to right,
    ${ColorPalette.HEX.AntiFlashWhite3} 4%,
    ${ColorPalette.HEX.Platinum} 25%,
    ${ColorPalette.HEX.AntiFlashWhite3} 36%
  );
  background-size: 1000px 100%;
  color: ${ColorPalette.Transparent};
  line-height: 1;
  vertical-align: middle;
  user-select: none;
`;

export default ShimmerBase;
